package com.ilussobsa.views

import com.lightningkite.kiteui.Routable
import com.lightningkite.kiteui.navigation.Page
import com.lightningkite.kiteui.reactive.*
import com.lightningkite.kiteui.views.ViewWriter
import com.lightningkite.kiteui.views.bold
import com.lightningkite.kiteui.views.direct.*
import com.lightningkite.kiteui.views.italic
import com.lightningkite.reactive.context.*
import com.lightningkite.reactive.core.*
import com.lightningkite.reactive.extensions.*
import com.lightningkite.reactive.lensing.*
import com.lightningkite.readable.*

@Routable("privacy")
class PrivacyPolicyScreen : Page, ControlsNavVisibility {
    override fun ReactiveContext.showNav() = false
    override fun ViewWriter.render() = scrolling - col {
        bold - text("iLusso Auctions – Privacy Policy")
        italic - text("Last Updated: May 29, 2025")
        text("This Privacy Policy describes the privacy practices of iLusso Auctions, Inc. (“iLusso,” “we,” “us,” or “our”).")
        separator()
        h3("1. ILUSSO AUCTIONS PLATFORM")
        text("iLusso Auctions is a digital, subscription-based online auction platform where iLusso, as the exclusive seller, offers new and pre-owned vehicles for sale to buyers. Our platform enables you—whether an individual consumer or a licensed dealer—to bid on and purchase vehicles in live, closed auctions. We collect and process personal information in order to operate, secure, and improve our services.")
        separator()
        h3("2. PERSONAL INFORMATION WE COLLECT")
        text("A. Information You Provide")
        text(" Account & Profile Data: Name, business or personal email and mailing address, phone number, profile photo (optional), and any company name or professional title you supply.")
        text(" Payment Details: Credit card number, expiration date, billing address, and any financing-related information (e.g., lender name, loan application data) you provide to bid or complete a purchase.")
        text(" Bid & Transaction Data: Records of bids placed, winning bids, invoices, purchase amounts, and related correspondence.")
        text(" Feedback & Support: Any messages, questions, or feedback you send when contacting customer support or responding to surveys.")
        text(" Marketing Preferences: Your choices about receiving promotional emails, alerts, and other communications.")
        text("B. Information We Collect Automatically")
        text(" Device & Usage Data: IP address, device type, operating system, browser type, screen resolution, and unique device identifiers.")
        text(" Interaction Data: Pages viewed, time spent on pages, navigation paths, ad clicks, auction participation metrics, and email open/click history.")
        text("C. Information from Third Parties")
        text(" Social & Public Sources: If you link or interact via social media platforms (e.g., X, Facebook, Instagram), we may receive basic profile information in accordance with their policies.")
        text(" Data Enrichment Services: We may obtain address verification or fraud-prevention data from trusted providers.")
        separator()
        h3("3. HOW WE USE YOUR INFORMATION")
        text("We use your personal information to:")
        text("1. Operate & Maintain the iLusso Auctions platform and manage your account.")
        text("2. Process Bids & Payments, verify payment methods, and enforce our non-performance and fee policies.")
        text("3. Communicate with you about your bids, purchases, account status, and platform updates.")
        text("4. Enhance & Personalize your experience, tailor vehicle recommendations, and send relevant promotions.")
        text("5. Analyze & Improve our services, develop new features, and detect fraud or misuse.")
        text("6. Comply with Legal Obligations and protect our rights, your rights, and the safety of our community.")
        separator()
        h3("4. SHARING YOUR INFORMATION")
        text("We may share your personal data with:")
        text(" Affiliates & Subsidiaries for the purposes described in this Policy.")
        text(" Service Providers (e.g., payment processors, hosting, customer support, analytics) who perform services on our behalf.")
        text(" Law Enforcement & Regulators when required by law or to protect our legal rights.")
        text(" Business Transferees in connection with a merger, acquisition, or sale of assets.")
        text(" Advertising & Marketing Partners for interest-based advertising (you can opt out—see section 6).")
        text("We do not sell your personal information to third parties for their own marketing purposes.")
        separator()
        h3("5. COOKIES & TRACKING TECHNOLOGIES")
        text("We use cookies, local storage, web beacons, and similar tools to:")
        text(" Remember your preferences and session state.")
        text(" Analyze platform usage and performance.")
        text(" Deliver personalized content and targeted ads.")
        text("You can manage or disable cookies via your browser settings, but this may affect platform functionality.")
        separator()
        h3("6. YOUR CHOICES & RIGHTS")
        text(" Access & Correction: You may request to review, update, or delete your personal data by contacting us.")
        text(" Opt Out of Marketing: Unsubscribe via links in our emails or by emailing support@ilusso.com.")
        text(" Limit Tracking: Use browser controls or industry opt-out tools (e.g., Digital Advertising Alliance, Network Advertising Initiative).")
        text(" Do Not Track: We do not currently respond to “Do Not Track” signals from browsers.")
        separator()
        h3("7. DATA RETENTION")
        text("We retain personal data as long as necessary to provide services, comply with legal obligations, enforce our agreements, and resolve disputes.")
        separator()
        h3("8. DATA SECURITY")
        text("We implement administrative, technical, and physical safeguards to protect your data. However, no system is impenetrable; please take care when sharing sensitive information online.")
        separator()
        h3("9. INTERNATIONAL TRANSFERS")
        text("Your information may be stored or processed in the United States. If you reside outside the U.S., please note your data may be transferred to and maintained on U.S. servers under U.S. laws.")
        separator()
        h3("10. CHILDREN’S PRIVACY")
        text("Our services are not directed to children under 18. We do not knowingly collect personal data from minors.")
        separator()
        h3("11. CHANGES TO THIS POLICY")
        text("We may update this Privacy Policy at any time. The “Last Updated” date will reflect the change. Continued use after updates constitutes acceptance.")
        separator()
        h3("12. CONTACT US")
        text("For questions or requests regarding your privacy, please contact:")
        text("Email: support@ilusso.com")
        text("Phone: (512) 676-1574")
    }
}